module.exports = __webpack_public_path__ + "static/media/mcdonalds.489cc0ee.png";